import { Component } from '@angular/core';

import { TranslationModule } from '../translation/translation.module';

@Component({
  selector: 'shrd-ft-footer-print-layout',
  templateUrl: './footer-print-layout.component.html',
  styleUrls: ['./footer-print-layout.component.scss'],
  standalone: true,
  imports: [TranslationModule]
})
export class FooterPrintLayoutComponent {}
